/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpsertUserCommand } from '../../models/upsert-user-command';

export interface ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params {
      body?: UpsertUserCommand
}

export function apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue.PATH = '/api/user';
